var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('span',{staticClass:"text-gray-400"},[_vm._v(_vm._s(_vm.loadingText))]):(_vm.convertedValue)?_c('span',[_vm._v(_vm._s(_vm.convertedValue))]):_c('span',{staticClass:"text-gray-400"},[_vm._v("N/A")])
}
var staticRenderFns = []

export { render, staticRenderFns }